module.exports = __webpack_public_path__ + "static/media/CICLO_5_GENERO_DIGITAL.03f18f3b.jpg";